export enum DictionaryType {
  ActiveSubstanceType = 0,
  Agrofag = 1,
  CultivationCrop = 2,
  CultivationInterCrop = 3,
  FertilizerType = 4,
  MachineType = 5,
  TreatmentType = 8
}
